import Resource from '@/plugins/sdk/Resource'
import { STRING, DATETIME, UUID, INTEGER, NUMBER, BOOLEAN, ITEM } from '@/plugins/sdk/fields'
import Pickup from '@/plugins/sdk/resources/Pickup'
import ItemType from '@/plugins/sdk/resources/Dictionary/ItemType'

export default class extends Resource {
  static name = 'pickup_item'

  static get fields () {
    return {
      id: new UUID(),
      description: new STRING(),
      pallet_count: new INTEGER(),
      item_count: new INTEGER(),
      length: new NUMBER(),
      width: new NUMBER(),
      height: new NUMBER(),
      largest_length: new NUMBER(),
      weight: new NUMBER(),
      is_dg: new BOOLEAN(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      type: new ITEM(ItemType),
      pickup: new ITEM(Pickup)
    }
  }
}
